module.exports = __webpack_public_path__ + "img/wiki-popup.f696fd90.png";